import { render } from "./Complete.vue?vue&type=template&id=f5d81972"
import script from "./Complete.vue?vue&type=script&lang=js"
export * from "./Complete.vue?vue&type=script&lang=js"
script.render = render

export default script